import type { SectionEntity } from './schemas';

/**
 * Readers over the subtype union. Only an ordinary row carries layout knobs —
 * a header row lays its slots out by its own rules and a zero row not at all —
 * so callers that just want "the gap this row puts between its columns" would
 * otherwise have to narrow the union at every site.
 *
 * They also take a row whose migration failed, which arrives raw and without
 * `props`: the structure adapters read it on the way past, and a throw there
 * would take the whole page down with that one row.
 */
export function sectionColumnGap(section: Pick<SectionEntity, 'props'>): number {
    const props = section.props ?? {};

    return 'columnGap' in props ? props.columnGap.value : 0;
}

/** Header rows only; see `slotVerticalMargin` on the specific schema. */
export function sectionSlotVerticalMargin(section: Pick<SectionEntity, 'props'>): number {
    const props = section.props ?? {};

    return 'slotVerticalMargin' in props ? props.slotVerticalMargin.value : 0;
}

export function sectionIsFlexibleWidths(section: Pick<SectionEntity, 'props'>): boolean {
    const props = section.props ?? {};

    return 'isFlexibleWidths' in props && props.isFlexibleWidths;
}
